module.exports = __webpack_public_path__ + "img/wa_logo-bw.025a7549.png";